import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/hour_reports',
    name: 'HourReport',
    component: {
      name: 'AdminHourReport',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'hour_report',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminHourReportIndex',
        component: () => import('../views/HourReportIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminHourReportNew',
        component: () => import('../views/HourReportInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminHourReportIndex' },
        },
      },
      {
        path: 'batch_new',
        name: 'AdminHourReportBatchNew',
        component: () => import('../views/HourReportBatchInput.vue'),
        meta: {
          action: 'new',
          customName: 'views.hour_report.index.batch_new',
          backRoute: { name: 'AdminHourReportIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminHourReportShow',
        component: () => import('../views/HourReportShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminHourReportIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminHourReportDetails',
            component: () => import('../views/HourReportDetails.vue'),
            meta: {
              backRoute: { name: 'AdminHourReportIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminHourReportEdit',
            component: () => import('../views/HourReportInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminHourReportDetails' },
            },
          },
          {
            path: 'logs',
            name: 'AdminHourReportLogs',
            component: () => import('../views/log/HourReportLogs.vue'),
            meta: {
              backRoute: { name: 'AdminHourReportIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/hour_reports',
    name: 'UserHourReport',
    component: {
      name: 'UserHourReport',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'hour_report',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserHourReportIndex',
        component: () => import('../views/HourReportUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserHourReportShow',
        component: () => import('../views/HourReportUserShow.vue'),
        meta: {
          backRoute: {
            name: 'UserHourReportIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserHourReportDetails',
            component: () => import('../views/HourReportUserDetails.vue'),
            meta: {
              backRoute: { name: 'UserHourReportIndex' },
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));